module.exports = __webpack_public_path__ + "333e469cb74060ae32e4a1d3c4829c16.gltf";